import { render, staticRenderFns } from "./SamCard.vue?vue&type=template&id=6d9db44e&scoped=true&shadow"
import script from "./SamCard.vue?vue&type=script&lang=js&shadow"
export * from "./SamCard.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamCard.vue?vue&type=style&index=0&id=6d9db44e&prod&lang=scss&scoped=true&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "6d9db44e",
  null
  ,true
)

export default component.exports